<div class="safe-container min-h-full w-full">
    <div
        class="mx-auto flex min-h-full w-full flex-col px-4 pb-4 md:px-6 md:pb-6"
        [ngClass]="[avoidShellHeader ? 'pt-24' : 'pt-4', contentClass]">
        <ng-content></ng-content>
    </div>
</div>
